export const BREAKPOINTS = {
  XSMALL: 0,
  SMALL: 413,
  MEDIUM: 840,
  LARGE: 1160,
  XLARGE: 1440,
};
